<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<!-- <style>
  @import "./../assets/web/css/layout.css";
  @import "./../assets/web/css/header.css";
  @import "./../assets/web/css/newsContent.css";
  @import "./../assets/web/css/newsInfo.css";
  @import "./../assets/web/css/newsList.css";
  /* @import "./../assets/web/css/content.css"; */
  @import "./../assets/web/css/footer.css";
  @import "./../assets/widget/css/widget.css";
  @import "./../assets/icon/css/icon.css";
  @import "./../assets/table/css/table.css";
</style> -->
<script>
  export default {
    name: "App",
    data() {
      return {

      };
    },
    created() {

    },
    mounted() {

    },
  }
</script>

<style>
</style>